// extracted by mini-css-extract-plugin
module.exports = {"selectDropdown":"PainelResumoFilter_selectDropdown__3pkF6"};